import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Alert, Upload, message, Table, Tooltip, Tag, Button } from 'antd';
import { InboxOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import readXlsxFile from 'read-excel-file';
import writeXlsxFile from 'write-excel-file';
import { saveAs } from 'file-saver';
import { validateBulk, uploadBulk } from 'utils/apis/expenses';
import intl from 'react-intl-universal';

const BulkExpensesUploadModal = props => {
  const standardKeys = [
    'svcPacName',
    'unitId',
    'unitNo',
    'electricity',
    'water',
    'internet',
    'cleaning',
    'laundry',
    'checkIn',
    'checkOut',
    'service',
    'bodywash',
    'lotion',
    'shampoo',
    'conditioner',
    'shaver',
    'toiletrolls',
    'toothbrush',
    'toothpaste',
    'haveError'
  ];
  const [loading, setLoading] = useState(false);
  const [validatedData, setValidatedData] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [column, setColumn] = useState([]);

  const handleUploadedTemplate = async value => {
    /* 
Flow
1. Check is file valid
2. Parse excel file
3. Check parsed file format
4. Compose data
5. Check value
 */
    // console.log(65, value.file);
    setUploadedFile([value.file]);

    var output = await parseExcel(value.file);

    const isSchemaValid = await validateFormat(output);
    if (isSchemaValid.error === true) {
      message.error(isSchemaValid.message);
      setUploadedFile([]);
      return;
    }

    var newData = [];
    for (let i = 0; i < output.rows.length; i++) {
      var item = output.rows[i];
      let errorList = [];

      errorList = [...errorList, ...output.errors.filter(err => err.row === i + 2)];

      newData.push({
        ...item,
        haveError: errorList
      });
    }
    // console.log(59, newData, output);
    setValidatedData(newData);

    setLoading(true);
    await validateBulk(newData).catch(err => {
      message.error('There is an error validating the data, please try again');
    });
    // console.log('apiValidatedData', apiValidatedData);
    let otherData = [];

    if (newData.length !== 0) {
      Object.keys(newData[0]).forEach(key => {
        if (!standardKeys.includes(key)) {
          otherData.push({
            title: key,
            dataIndex: key,
            key: key
          });
        }
      });
    }

    // if (apiValidatedData.status === 200) {
    setValidatedData(newData);
    setColumn(
      [
        {
          title: 'Status',
          sorter: (a, b) => a.haveError.length - b.haveError.length,
          render: index => {
            if (index.haveError.length === 0) {
              return <Tag color="green">Accepted</Tag>;
            } else {
              return (
                <Tooltip
                  title={
                    <Row>
                      <Col span={24} style={{ fontWeight: 600 }}>
                        Error List :
                      </Col>
                      {index.haveError.map((value, index) => (
                        <Col key={index} span={24}>
                          {index + 1}. {value.column} {value.error}
                        </Col>
                      ))}
                    </Row>
                  }
                >
                  <Tag color="red">
                    <QuestionCircleOutlined /> Error
                  </Tag>
                </Tooltip>
              );
            }
          }
        },
        {
          title: 'Service Package Name',
          dataIndex: 'svcPacName',
          key: 'svcPacName'
        },
        {
          title: 'Unit Id',
          dataIndex: 'unitId',
          key: 'unitId'
        },
        {
          title: 'Unit Name',
          dataIndex: 'unitNo',
          key: 'unitNo'
        },
        {
          title: 'Electricity',
          dataIndex: 'electricity',
          key: 'electricity'
        },
        {
          title: 'Water',
          dataIndex: 'water',
          key: 'water'
        },
        {
          title: 'Internet',
          dataIndex: 'internet',
          key: 'internet'
        },
        {
          title: 'Cleaning',
          dataIndex: 'cleaning',
          key: 'cleaning'
        },
        {
          title: 'Laundry',
          dataIndex: 'laundry',
          key: 'laundry'
        },
        {
          title: 'Check-In',
          dataIndex: 'checkIn',
          key: 'checkIn'
        },
        {
          title: 'Check-Out',
          dataIndex: 'checkOut',
          key: 'checkOut'
        },
        {
          title: 'Service',
          dataIndex: 'service',
          key: 'service'
        },
        {
          title: 'Bodywash',
          dataIndex: 'bodywash',
          key: 'bodywash'
        },
        {
          title: 'Lotion',
          dataIndex: 'lotion',
          key: 'lotion'
        },
        {
          title: 'Shampoo',
          dataIndex: 'shampoo',
          key: 'shampoo'
        },
        {
          title: 'Conditioner',
          dataIndex: 'conditioner',
          key: 'conditioner'
        },
        {
          title: 'Shaver',
          dataIndex: 'shaver',
          key: 'shaver'
        },
        {
          title: 'Toiletrolls',
          dataIndex: 'toiletrolls',
          key: 'toiletrolls'
        },
        {
          title: 'Toothbrush',
          dataIndex: 'toothbrush',
          key: 'toothbrush'
        },
        {
          title: 'Toothpaste',
          dataIndex: 'toothpaste',
          key: 'toothpaste'
        }
      ].concat(otherData)
    );
    // }

    setLoading(false);
  };

  const validateFormat = output => {
    // console.log(120, output);
    if (output.rows.length === 0) {
      setUploadedFile([]);
      return {
        error: true,
        message: intl.get('expenses.bulkUpload.invalidSchema').d('Invalid schema')
      };
    }
    if (output.errors.length > 0) {
      const errMsg = intl.get('expenses.bulkUpload.containError').d('Contain error please fix and try again');
      message.error(errMsg);
      return {
        error: false,
        message: errMsg
      };
    }
    return {
      error: false
    };
  };

  const parseExcel = async file => {
    const excelHeader = await new Promise((resolve, reject) => {
      readXlsxFile(file)
        .then(rows => {
          // console.log(105, rows);
          resolve(rows);
        })
        .catch(err => {
          message.error(intl.get('expenses.bulkUpload.invalidExcelFile').d('Invalid Excel File'));
          reject(err);
        });
    });
    const totalColumns = excelHeader[0].length;
    let schema = {};
    for (let i = 0; i < totalColumns; i++) {
      if (i < 3) {
        schema[`${excelHeader[0][i]}`] = {
          prop: `${excelHeader[0][i]}`,
          type: String,
          required: true
        };
      } else {
        schema[`${excelHeader[0][i]}`] = {
          prop: `${excelHeader[0][i]}`,
          type: Number,
          required: true
        };
      }
    }

    return new Promise((resolve, reject) => {
      readXlsxFile(file, {
        schema: schema
      })
        .then(output => {
          resolve(output);
        })
        .catch(err => {
          message.error(intl.get('expenses.bulkUpload.invalidExcelFile').d('Invalid Excel File'));
          reject(err);
        });
    });
  };

  const resetUpload = () => {
    setUploadedFile([]);
    setValidatedData([]);
  };

  const handleUpload = async () => {
    setLoading(true);
    const res = await uploadBulk({
      validatedData: validatedData,
      year: props.year,
      month: props.month,
      servicePackages: props.servicePackages
    });

    if (res && res.status === 200) {
      Modal.success({
        title: res.data.message,
        onOk: () => {
          window.location.reload();
        }
      });
    } else {
      Modal.error({
        title: intl.get('expenses.bulkUpload.bulkUploadFailed').d('Bulk upload failed'),
        content: res.data ? res.data.message : intl.get('expenses.bulkUpload.tryAgainLater').d('Please try again later'),
        onOk: () => {
          window.location.reload();
        }
      });
    }

    props.onCancel();
    setLoading(false);
  };

  return (
    <Modal
      title={intl.get('expenses.bulkUpload.modalTitle').d('Bulk Expenses Update')}
      visible={props.visible}
      onOk={handleUpload}
      onCancel={() => {
        resetUpload();
        props.onCancel();
      }}
      width={'75%'}
      okText={intl.get('expenses.bulkUpload.upload').d('Upload')}
      okButtonProps={{
        disabled: validatedData.length === 0 || validatedData.filter(x => x.haveError.length > 0).length > 0,
        loading: loading
      }}
      cancelText={intl.get('expenses.headerLabels.close').d('Close')}
    >
      <Alert
        description={
          <div>
            <p>
              {intl.get('expenses.bulkUpload.downloadTemplateIntro').d('Download template record:')}{' '}
              {/* <CSVLink filename={props.csvName} data={props.csvTemplate} className="exp-csv"> */}
              <Button
                id="csv-button3-host"
                type="primary"
                icon="download"
                onClick={async () => {
                  // console.log('props.csvTemplate', props.csvTemplate);
                  await writeXlsxFile(props.csvTemplate, {
                    schema: [
                      {
                        column: 'svcPacName',
                        type: String,
                        value: data => data.svcPacName
                      },
                      {
                        column: 'unitId',
                        type: String,
                        value: data => data.unitId
                      },
                      {
                        column: 'unitNo',
                        type: String,
                        value: data => data.unitNo
                      },
                      {
                        column: 'electricity',
                        type: Number,
                        value: data => data.electricity
                      },
                      {
                        column: 'water',
                        type: Number,
                        value: data => data.water
                      },
                      {
                        column: 'internet',
                        type: Number,
                        value: data => data.internet
                      },
                      {
                        column: 'cleaning',
                        type: Number,
                        value: data => data.cleaning
                      },
                      {
                        column: 'laundry',
                        type: Number,
                        value: data => data.laundry
                      },
                      {
                        column: 'checkIn',
                        type: Number,
                        value: data => data.checkIn
                      },
                      {
                        column: 'checkOut',
                        type: Number,
                        value: data => data.checkOut
                      },
                      {
                        column: 'service',
                        type: Number,
                        value: data => data.service
                      },
                      {
                        column: 'bodywash',
                        type: Number,
                        value: data => data.bodywash
                      },
                      {
                        column: 'lotion',
                        type: Number,
                        value: data => data.lotion
                      },
                      {
                        column: 'shampoo',
                        type: Number,
                        value: data => data.shampoo
                      },
                      {
                        column: 'conditioner',
                        type: Number,
                        value: data => data.conditioner
                      },
                      {
                        column: 'shaver',
                        type: Number,
                        value: data => data.shaver
                      },
                      {
                        column: 'toiletrolls',
                        type: Number,
                        value: data => data.toiletrolls
                      },
                      {
                        column: 'toothbrush',
                        type: Number,
                        value: data => data.toothbrush
                      },
                      {
                        column: 'toothpaste',
                        type: Number,
                        value: data => data.toothpaste
                      }
                    ]
                  }).then(blob => {
                    saveAs(blob, `${props.csvName.toString()}.xlsx`);
                  });
                }}
              >
                {`${props.csvName.toString()}.xlsx`}
                {/* {intl.get('expenses.headerLabels.template').d('Download Template Link')} */}
              </Button>
              {/* </CSVLink> */}
            </p>
            <p>
              {intl.get('expenses.bulkUpload.step1').d('1. Download the record template and fill in the data.')} <br />
              {intl
                .get('expenses.bulkUpload.step2')
                .d("2. You may add additional columns, those columns will be considered under 'Others' expenses.")}{' '}
              <br />
              {intl.get('expenses.bulkUpload.step3').d('3. Export/Save the data as .xlsx file.')} <br />
              {intl.get('expenses.bulkUpload.step4').d('4. Click the area below to select file or drag file into area below to import data.')} <br />
              {intl.get('expenses.bulkUpload.step5').d('5. Click Upload to save the data into system.')} <br />
              <br />
              <b>{intl.get('expenses.bulkUpload.noteLabel').d('Note:')}</b> <br />
              <span style={{ backgroundColor: '#FFFF00', fontWeight: '600' }}>
                {intl.get('expenses.bulkUpload.noteHighlight').d('- Please do not delete/remove any rows of data.')}
              </span>
              <br />
              {intl.get('expenses.bulkUpload.noteXlsx').d('- Only .xlsx file format is supported.')} <br />
            </p>
          </div>
        }
        type="info"
        showIcon
        style={{
          marginBottom: 16
        }}
      />

      {validatedData.length === 0 ? (
        <Upload.Dragger beforeUpload={() => false} onChange={handleUploadedTemplate} fileList={[]} withCredentials>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{intl.get('expenses.bulkUpload.draggerMain').d('Click or drag file to this area to upload')}</p>
          <p className="ant-upload-hint">
            {intl
              .get('expenses.bulkUpload.draggerHint')
              .d('Support only for template upload. Strictly prohibit from uploading others data or other brand files')}
          </p>
        </Upload.Dragger>
      ) : (
        <Table
          bordered
          size="small"
          rowKey={'id'}
          scroll={{
            x: true
          }}
          columns={column}
          dataSource={validatedData}
          loading={loading}
        />
      )}
    </Modal>
  );
};

export default BulkExpensesUploadModal;
